import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.some.js";
import { computed, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useHead } from '@vueuse/head';
import ViewMode from "@/components/modules/view-mode.vue";
import Breadcrumb from "@/components/modules/breadcrumb.vue";
import List from "@/components/list";
import { languageService, UtilityService, gaService } from '@/utils';
import { postQuery } from "@/api";
import { videoTypeEnum, ApiReturnCodeEnum } from "@/enums/api";
import { viewModeEnum } from "@/enums/components/list";
export default {
  name: "HomeExplorer",
  components: {
    ViewMode,
    Breadcrumb,
    List
  },
  setup() {
    const {
      getLanguagePath,
      getLanguageId,
      getLocaleMessege
    } = languageService;
    const {
      parseAndDecode,
      preprocessData,
      updateBookmarkStatusProcess
    } = UtilityService;
    const route = useRoute();
    const router = useRouter();
    const breadcrumbData = ref([]);
    const groupData = ref([]);
    const viewMode = ref(viewModeEnum.ICON);
    const isShowVideMode = ref(false);
    const isFinishQuery = ref(false);
    const productRootPath = computed(() => route.params.path[0]);
    const logo = computed(() => productLogos[productRootPath.value.toLowerCase()]);
    const pageSize = 60;
    const listErrorMsg = ref("");
    let pageNo = 1;
    let groupDataCount = 0;
    let queryRequest = null;
    const isLastPage = ref(false);
    const productLogos = {
      "iclone": require("@/assets/images/home-explorer/Logo_IC.png"),
      "character-creator": require("@/assets/images/home-explorer/Logo_CC.png"),
      "cartoon-animator": require("@/assets/images/home-explorer/Logo_CTA.png"),
      "actorcore": require("@/assets/images/home-explorer/Logo_AC.png"),
      "smart-gallery": require("@/assets/images/home-explorer/Logo_SG.png"),
      "workgroup": require("@/assets/images/home-explorer/Logo_WorkGroup.png"),
      "smart-search": require("@/assets/images/home-explorer/Logo_Smart_Search.png")
    };
    useHead({
      title: computed(() => {
        if (breadcrumbData.value.length > 1) {
          const product = breadcrumbData.value[0]?.name;
          const group = breadcrumbData.value[breadcrumbData.value.length - 1]?.name;
          return `${group} - ${product} ${getLocaleMessege("COMMON").TUTOTIAL}`;
        }
        return null;
      })
    });
    const init = () => {
      pageNo = 1;
      groupData.value = [];
      groupDataCount = 0;
      breadcrumbData.value = [];
      viewMode.value = viewModeEnum.ICON;
      isFinishQuery.value = false;
      isLastPage.value = false;
      isShowVideMode.value = false;
      listErrorMsg.value = "";
    };
    const processBreadcrumbData = (path, locationBar) => {
      const data = locationBar.map(({
        name,
        urlName
      }) => {
        path += urlName + '/';
        return {
          name,
          path
        };
      });
      data.shift();
      return data;
    };
    const getCourseData = () => {
      const errorMassage = getLocaleMessege("COMMON").API_ERROR_TITLE + getLocaleMessege("COMMON").API_ERROR_DESCRIPTION;
      isFinishQuery.value = false;
      if (queryRequest) {
        queryRequest.cancel();
      }
      queryRequest = postQuery({
        category: ["home", ...route.params.path],
        lang: getLanguageId(),
        pageSize,
        pageNo
      });
      queryRequest.then(data => {
        const {
          items,
          count,
          locationBar
        } = data;
        groupData.value = groupData.value.concat(items);
        groupDataCount = count;
        breadcrumbData.value = processBreadcrumbData(getLanguagePath(), locationBar);
        isShowVideMode.value = groupData.value.some(item => item.type === 3);
        listErrorMsg.value = "";
        isLastPage.value = pageSize * pageNo++ >= groupDataCount;
        isFinishQuery.value = true;
      }, response => {
        isFinishQuery.value = true;
        if (response?.data?.apiStatus !== ApiReturnCodeEnum.RESPONSE_INTERCEPT) {
          if (response?.data?.apiStatus === ApiReturnCodeEnum.ID_NO_DATA_FOUND) {
            const {
              locationBar
            } = parseAndDecode(response.data.result);
            if (locationBar) {
              breadcrumbData.value = processBreadcrumbData(getLanguagePath(), locationBar);
              listErrorMsg.value = getLocaleMessege("COMMON").NO_SEARCH_RESULTS_FOUND;
            } else {
              router.push(getLanguagePath());
            }
          } else {
            console.log(`request error, Response = ${response?.status}, ReturnCode = ${response?.data?.apiStatus}`);
            listErrorMsg.value = errorMassage;
          }
        }
      }).catch(error => {
        console.log(error);
        isFinishQuery.value = true;
        listErrorMsg.value = errorMassage;
      });
    };
    onMounted(() => {
      getCourseData();
    });
    watch(() => route.params, () => {
      if (route.params.path && (route.name === "homeExplorer" || route.name === "homeExplorer-lang")) {
        init();
        getCourseData();
      }
      isLastPage.value = false;
    });
    const updateBookmarkStatus = (newBookmarkStatus, item) => {
      updateBookmarkStatusProcess(item.id, newBookmarkStatus, videoTypeEnum.TUTORIAL).then(() => {
        const foundIndex = groupData.value.findIndex(element => element.id == item.id);
        groupData.value[foundIndex].isBookmarked = newBookmarkStatus;
      }).catch(error => {
        console.log(error);
      });
    };
    const impressionGAtrack = (item, position) => {
      gaService.recordProductImpression(item, "home", position);
    };
    const clickGAtrack = (item, position) => {
      gaService.recordProductClick(item, "home", position);
    };
    return {
      groupData,
      breadcrumbData,
      viewMode,
      isShowVideMode,
      logo,
      updateBookmarkStatus,
      getLanguagePath,
      preprocessData,
      productRootPath,
      listErrorMsg,
      impressionGAtrack,
      clickGAtrack,
      isFinishQuery,
      isLastPage,
      getCourseData
    };
  }
};